import React from 'react';
import { Link } from 'react-router-dom';
import { getLifecycleState } from '../utils/lifecycleUtils.js';

function LifecycleActionButtons({
  item,
  itemId,
  entityLabel = 'persoon',
  editPath,
  loadingId = null,
  onAction,
  size = 'sm',
  roundedClass = 'rounded-0',
  compact = false,
  stopPropagation = true
}) {
  const {
    isAnonymized,
    showDeactivate,
    showReactivate,
    showUnenroll,
    showReenroll,
    showArchive,
    showAnonymize
  } = getLifecycleState(item);

  const isBusy = loadingId === itemId;

  const handleClick = (e, action) => {
    if (stopPropagation) e.stopPropagation();
    if (!onAction || isBusy) return;
    onAction(itemId, action, entityLabel, item);
  };

  const buttonStyle = compact
    ? { fontSize: '10px', padding: '2px 5px' }
    : undefined;

  return (
    <div
      className="d-flex flex-wrap gap-1"
      onClick={(e) => stopPropagation && e.stopPropagation()}
    >
      {!isAnonymized && editPath && (
        <Link
          to={editPath}
          id="edit-button"
          className={`btn btn-${size} btn-warning ${roundedClass}`}
          style={buttonStyle}
          onClick={(e) => stopPropagation && e.stopPropagation()}
        >
          Bewerk
        </Link>
      )}

      {showDeactivate && (
        <button
          type="button"
          id="deactivate-button"
          className={`btn btn-${size} btn-outline-warning ${roundedClass}`}
          style={buttonStyle}
          onClick={(e) => handleClick(e, 'deactivate')}
          disabled={isBusy}
        >
          Deactiveer
        </button>
      )}

      {showReactivate && (
        <button
          type="button"
          id="reactivate-button"
          className={`btn btn-${size} btn-outline-success ${roundedClass}`}
          style={buttonStyle}
          onClick={(e) => handleClick(e, 'reactivate')}
          disabled={isBusy}
        >
          Heractiveer
        </button>
      )}

      {showUnenroll && (
        <button
          type="button"
          id="unenroll-button"
          className={`btn btn-${size} btn-outline-warning ${roundedClass}`}
          style={buttonStyle}
          onClick={(e) => handleClick(e, 'unenroll')}
          disabled={isBusy}
        >
          Uitschrijven
        </button>
      )}

      {showReenroll && (
        <button
          type="button"
          id="reenroll-button"
          className={`btn btn-${size} btn-outline-success ${roundedClass}`}
          style={buttonStyle}
          onClick={(e) => handleClick(e, 'reenroll')}
          disabled={isBusy}
        >
          Herinschrijven
        </button>
      )}

      {showArchive && (
        <button
          type="button"
          id="archive-button"
          className={`btn btn-${size} btn-outline-secondary ${roundedClass}`}
          style={buttonStyle}
          onClick={(e) => handleClick(e, 'archive')}
          disabled={isBusy}
        >
          Archiveer
        </button>
      )}

      {showAnonymize && (
        <button
          type="button"
          id="anonymize-button"
          className={`btn btn-${size} btn-outline-danger ${roundedClass}`}
          style={buttonStyle}
          onClick={(e) => handleClick(e, 'anonymize')}
          disabled={isBusy}
        >
          Anonimiseer
        </button>
      )}
    </div>
  );
}

export default LifecycleActionButtons;